<template>
    <div
      class="modal fade createNewModal"
      id="AddElementModal"
      tabindex="-1"
      ref="addElementModalRef"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content p-15 p-md-40">
          <div class="modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25">
            <h5 class="modal-title fw-bold text-black">{{ title }}</h5>
          </div>
          <div class="modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25">
            <Form ref="elementForm" @submit="addElement" :validation-schema="elementSchema">
                
                <div class="row">

                  
                  <div class="col-md-12">
                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                        Désignation <span class="text-danger">*</span>
                      </label>
                      <Field name="nom" type="text" 
                      class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer la désignation"/>
                      <ErrorMessage name="nom" class="text-danger"/>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                        Description <span class="text-danger">*</span>
                      </label>
                      <Field name="description" type="text" 
                      class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer la description"/>
                      <ErrorMessage name="description" class="text-danger"/>
                    </div>
                  </div>

                </div>
                
              
              <button
                class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16"
                type="submit">
                {{ btntext }}
              </button>
          </Form>
          </div>
          <button
            type="button"
            class="btn-close shadow-none"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="resetValue()"
          ></button>
        </div>
      </div>
    </div>
  </template>
  
  <script lang="ts">
  import { defineComponent, ref, watch, onMounted } from 'vue';
  import { Form, Field, ErrorMessage } from 'vee-validate';
  import ApiService from '../../services/ApiService';
  import * as Yup from 'yup';
  import { Categorie } from '../../models/Categorie';
  import { error , success, hideModal } from '../../utils/utils';
  import Multiselect from '@vueform/multiselect';
  
  export default defineComponent({
      name: "AddCollectionModal",
      components: {
      Form,
      Field,
      ErrorMessage,
    },
    props: {
      item: {
        type: Number,
        default: 0,
      }
    },
    setup(props, { emit }){
      const elementSchema = Yup.object().shape({
        nom: Yup.string().required('La désignation est obligatoire'),
        description: Yup.string().required('La description est obligatoire'),
      });
  
      
      const elementForm = ref<Categorie | null>(null);
      const addElementModalRef = ref<null | HTMLElement>(null);
      const paysOptions = ref<Array<{ value: number; label: string }>>([]);
      const paysSelected = ref<number | null>(null);

      const isUPDATE = ref(false);
      const title = ref("Ajouter une collection");
      const btntext = ref('Ajouter');
  
      watch(() => props.item, (newValue) => {
        getCategorieClient(newValue);
        isUPDATE.value = true;
        btnTitle();
      });
  
      const btnTitle = async () => {
        if (isUPDATE.value) {
           title.value = "Modifier la collection";
           btntext.value = "Modifier";
        }else{
           title.value = "Ajouter une collection";
           btntext.value = "Ajouter";
        }
      }
    
      const getCategorieClient = async (id: number) => {
        return ApiService.get("/collections/"+id)
        .then(({ data }) => {
          const donnees = data.data;
          for (const key in donnees) {
            elementForm.value?.setFieldValue(key, 
            (typeof donnees[key] === 'object' && donnees[key] !== null)? donnees[key].id :donnees[key]
            );
          }
          emit('openmodal', addElementModalRef.value);
  
        })
        .catch(({ response }) => {
          error(response.data.message)
        });
      }

      const addElement = async (values: any, elementForm) => {
        
        values = values as Categorie;
        if(isUPDATE.value){
          ApiService.put("/collections/"+values.id,values)
          .then(({ data }) => {
              if(data.code == 200) { 
                success(data.message);
                elementForm.resetForm();
                hideModal(addElementModalRef.value);
                isUPDATE.value=false;
                btnTitle();
                emit('close');
              }
          })
          .catch(({ response }) => {
              error(response.data.message);
          });
        }else{
          ApiService.post("/collections",values)
          .then(({ data }) => {
              if(data.code == 201) { 
                success(data.message);
                elementForm.resetForm();
                hideModal(addElementModalRef.value);
                emit('close');
              }
          })
          .catch(({ response }) => {
              error(response.data.message);
          });
        }
      };

      
  
      const resetValue = () => {
        const formFields = document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input, textarea');
          isUPDATE.value=false;
        formFields.forEach(field => {
          field.value = '';
        });
        btnTitle()
      };
  
      return { 
        elementSchema,
        addElementModalRef,
        addElement,
        elementForm,
        title,btntext,
        resetValue,
        paysOptions,
        paysSelected,
       
      };
    },
  });
  </script>